import { Wrench, Cog } from "lucide-react";

interface SpinningToolsProps {
  className?: string;
}

export function SpinningTools({ className }: SpinningToolsProps) {
  return (
    <div className="relative flex items-center justify-center w-4 h-4">
      {/* Background spinning cog */}
      <Cog
        className="w-4 h-4 animate-spin absolute text-[var(--color-header-accent,#0A74FF)]" 
        style={{ animationDuration: '8s' }} 
      />
      
      {/* Foreground static wrench */}
      <Wrench 
        className="w-2.5 h-2.5 relative z-10 text-[var(--color-header-accent,#0A74FF)]"
      />
    </div>
  );
}
